import * as React from "react";
const SvgSignalCellularConnectedNoInternet2Bar = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.3,
  d: "M22 8V2L2 22h16V8h4z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z",
  fill: "currentColor"
}));
export default SvgSignalCellularConnectedNoInternet2Bar;